import axios from "axios";
const API_HOST = process.env.REACT_APP_API_HOST;

class introducerService {

  searchIntroducerList(user , search) {
    return axios({
      method: "get",
      url: `${API_HOST}/api/superadmin/Introducer-id?search=${search}`,
      headers: {
        Authorization: `Bearer ${user.token}`,
      },
    });
  }

    createIntroducer(data, user) {
    console.log("user", user);
    return axios({
      method: "post",
      url: API_HOST + "/api/admin/accounts/introducer/register",
      data: data,
      headers: {
        Authorization: `Bearer ${user.token}`,
      },
    });
  }

  introducerAllTransactionReport(user, data, page, limit) {
    return axios({
      method: "post",
      url: `${API_HOST}/api/admin/introducer-account-summary?page=${page}&pageSize=${limit}`,
      data: data,
      headers: {
        Authorization: `Bearer ${user.token}`,
      },
    });
  }


  
  deleteIntroducerTransaction(data, user) {
    return axios({
      method: "post",
      url: `${API_HOST}/api/admin/save-introducer-transaction-request`,
      data: data,
      headers: {
        Authorization: `Bearer ${user.token}`,
      },
    });
  }


    introducerTransactionRequestes(user) {
    return axios({
      method: "get",
      url: `${API_HOST}/api/superadmin/view-edit-introducer-transaction-requests`,
      headers: {
        Authorization: `Bearer ${user.token}`,
      },
    });
  }


    isDeleteApprove(_id, user) {
    console.log(user);
    return axios({
      method: "post",
      url: `${API_HOST}/api/delete-introducer-transaction/${_id}`,
      headers: {
        Authorization: `Bearer ${user.token}`,
      },
    });
  }

    isDeleteReject(id, user) {
    return axios({
      method: "delete",
      url: `${API_HOST}/api/reject/introducer-detail/${id}`,
      headers: {
        Authorization: `Bearer ${user.token}`,
      },
    });
  }
  
}

export default new introducerService();
